import { render, staticRenderFns } from "./practice-content.vue?vue&type=template&id=7c046a6f"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./practice-content.vue?vue&type=style&index=0&id=7c046a6f&prod&lang=less"
import style1 from "./practice-content.vue?vue&type=style&index=1&id=7c046a6f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports